{
    "Accessibility menu": "Saavutettavuusvalikko",
    "Close": "Sulje",
    "Text and Reading": "Teksti ja lukeminen",
    "Navigation and Interaction": "Navigointi ja vuorovaikutus",
    "Text Align": "Tekstin tasaus",
    "Align Left": "Tasaa vasemmalle",
    "Align Center": "Tasaa keskelle",
    "Align Right": "Tasaa oikealle",
    "Adjust Font Size": "Säädä fonttikokoa",
    "Highlight Title": "Korosta otsikko",
    "Highlight Links": "Korosta linkit",
    "Readable Font": "Helposti luettava fontti",
    "Color and Contrast": "Väri ja kontrasti",
    "Dark Contrast": "Tumma kontrasti",
    "Light Contrast": "Vaalea kontrasti",
    "High Contrast": "Korkea kontrasti",
    "High Saturation": "Korkea kylläisyys",
    "Low Saturation": "Matala kylläisyys",
    "Monochrome": "Yksivärinen",
    "Tools": "Työkalut",
    "Reading Guide": "Lukemisopas",
    "Big Cursor": "Iso kohdistin",
    "Increase Font Size": "Suurenna fonttikokoa",
    "Decrease Font Size": "Pienennä fonttikokoa",
    "Letter Spacing": "Kirjainten välistys",
    "Line Height": "Rivin korkeus",
    "Font Weight": "Fontin paksuus",
    "Dyslexia Font": "Dysleksiafontti",
    "Language": "Kieli",
    "Accessibility widget": "Avaa saavutettavuusvalikko",
    "Accessibility Profiles": "Saavutettavuusprofiilit",
    "Cognitive Disability": "Kognitiivinen vamma",
    "Seizure Safe": "Turvallinen epilepsialle",
    "Accessibility statement": "Saavutettavuusseloste",
    "ADHD": "ADHD",
    "Low Vision": "Heikkonäköisyys",
    "Pause Animations": "Pysäytä animaatiot",
    "Animation paused": "Animaatio keskeytetty",
    "Reset all settings": "Palauta asetukset",
    "Shortcut:": "Pikanäppäin:",
    "Epilepsy Safe Mode": "Epilepsiaturvallinen tila",
    "Mute sounds": "Mykistä äänet",
    "Page read": "Lue sivu",
    "Page read controls": "Sivun lukemisen hallinta",
    "Pause": "Keskeytä",
    "Resume": "Jatka",
    "Stop": "Pysäytä",
    "Settings": "Asetukset",
    "Speed": "Nopeus",
    "Voice": "Ääni",
    "Close accessibility menu": "Sulje saavutettavuusvalikko",
    "Back to accessibility menu": "Takaisin saavutettavuusvalikkoon",
    "Search languages": "Hae kieliä",
    "Selected language": "Valittu kieli",
    "View accessibility statement (opens in new window)": "Näytä saavutettavuusseloste (avautuu uuteen ikkunaan)",
    "Visit CookieYes website (opens in new window)": "Käy CookieYes-sivustolla (avautuu uuteen ikkunaan)",
    "Reset all accessibility settings to default": "Palauta kaikki saavutettavuusasetukset oletusarvoihin"
}
